import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppConfig } from 'src/app/app.config';
import { DiscussionService } from 'src/app/shared-service/services/discussion.service';

@Component({
  selector: 'app-preview-post-image',
  templateUrl: './preview-post-image.component.html',
  styleUrls: ['./preview-post-image.component.css']
})
export class PreviewPostImageComponent implements OnInit {

  image='';
  baseUrl = '';
  rootUrl = '';
  playstoreLink = '';
  phoneNo = '';
  address = '';
  emailId = '';
  isdCode = '';
  domain = '';
  titleName ='';
  imageUrl='';

  constructor(public bsModalRef: BsModalRef,public discussionService: DiscussionService,private config: AppConfig) {
    this.baseUrl = this.config.getConfig('DISCUSS_BASE_URL');
    this.rootUrl = this.config.getConfig('DISCUSS_API_URL');
    this.imageUrl=this.config.getConfig('DISCUSS_IMAGE_URL');
    this.playstoreLink =  this.config.getConfig('MOBILE_PLAYSTORE_URL');
    this.phoneNo =  this.config.getConfig('PHONE_NO');
    this.address =  this.config.getConfig('ADDRESS');
    this.emailId =  this.config.getConfig('EMAIL_ID');
    this.isdCode = this.config.getConfig('PHONE_ISD_CODE');
    this.domain = this.config.getConfig('DOMAIN');
    this.titleName =this.config.getConfig('TITLE');
  }

  ngOnInit(): void {
  }

}
